"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOnlineIdentity = void 0;
var react_1 = require("react");
var useOnlineIdentity = function () {
    var _a = (0, react_1.useState)({}), authenticationRequired = _a[0], setAuthenticationRequired = _a[1];
    var _b = (0, react_1.useState)({}), authenticationExpiringSoon = _b[0], setAuthenticationExpiringSoon = _b[1];
    var create = function (_a, path) {
        var appID = _a.appID, enableDittoCloudSync = _a.enableDittoCloudSync, customAuthURL = _a.customAuthURL;
        return {
            type: 'onlineWithAuthentication',
            appID: appID,
            enableDittoCloudSync: enableDittoCloudSync,
            customAuthURL: customAuthURL,
            authHandler: {
                authenticationRequired: function () {
                    setAuthenticationRequired(function (currentAuthRequired) {
                        var _a;
                        return (__assign(__assign({}, currentAuthRequired), (_a = {}, _a[path] = true, _a)));
                    });
                },
                authenticationExpiringSoon: function (authenticator, tokenExpiresInSeconds) {
                    setAuthenticationExpiringSoon(function (currentAuthExpiringSoon) {
                        var _a;
                        return (__assign(__assign({}, currentAuthExpiringSoon), (_a = {}, _a[path] = tokenExpiresInSeconds, _a)));
                    });
                },
            },
        };
    };
    var getAuthenticationRequired = function (forPath) {
        return forPath in authenticationRequired;
    };
    var getTokenExpiresInSeconds = function (forPath) {
        return forPath in authenticationExpiringSoon
            ? authenticationExpiringSoon[forPath]
            : null;
    };
    return {
        create: create,
        getAuthenticationRequired: getAuthenticationRequired,
        getTokenExpiresInSeconds: getTokenExpiresInSeconds,
    };
};
exports.useOnlineIdentity = useOnlineIdentity;
//# sourceMappingURL=useOnlineIdentity.js.map